import dayjs from 'dayjs'
import { UserData } from '../types/user/types'

const TEST_KEYS = [
  'cognition',
  'ad8',
  'sitToStand',
  'nutrition',
  'vision',
  'hearing',
  'mood',
  'handgrip',
  'exhaustion',
  'gaitSpeed',
  'physicalActivity',
  'bloodPressure',
] as const

export const getLastTestDate = (userData: UserData | null | undefined): dayjs.Dayjs | null => {
  if (!userData) return null
  let latest: dayjs.Dayjs | null = null
  TEST_KEYS.forEach((key) => {
    const records: any[] = (userData as any)[key] || []
    records.forEach((record) => {
      const timestamp = record?.creationTimestamp || record?.testTimestamptz
      if (!timestamp) return
      const date = dayjs(timestamp)
      if (date.isValid() && (!latest || date.isAfter(latest))) latest = date
    })
  })
  return latest
}
